import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LgvNavItem } from '../../../core/core.module';
import { BehaviorSubject } from 'rxjs';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';
import { LgvFormlyModel } from '../../../data-models/formly.model';

@Component({
    selector: 'lgv-section-title-navigation',
    templateUrl: './section-title-navigation.component.html',
    styleUrls: ['./section-title-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionTitleNavigationComponent implements OnInit {

    @Input() title: string;

    _navItems: LgvNavItem[] = null;
    navItems$ = new BehaviorSubject(this._navItems);

    selectedNavItem: any = null;

    constructor(private lgvFormSvc: LgvFormUtilityService) { }

    ngOnInit(): void {

        let root = this.lgvFormSvc.getThisFieldGroupObj(-1, -1);
        let tmpNavArray: any[] = [];

        let index = 0;
        for (let o of root.appObj.fieldGroup) {
            let summary = this.lgvFormSvc.getChangeSummaryForLevel(index, -1);
            if (summary) {
                tmpNavArray.push({
                    name: o.props.label,
                    level: index
                });
            }

            index++;
        }

        // special handling for Review & Submit because it isn't a "section"
        tmpNavArray.push({ name: 'Review & Submit', level: -2 });
        tmpNavArray.push({ name: 'Congrats on submitting your loan application!', level: -2 });
        tmpNavArray.push({ name: 'Let`s keep working on your loan application!', level: -2 });

        if (this.title) {
            let item = tmpNavArray.find(x => x.name === this.title);
            if (item) {
                this.selectedNavItem = item;
            }
        }

        if (!this.selectedNavItem && tmpNavArray.length > 0) {

            let curLevel1 = this.lgvFormSvc.curLevel1$.value;
            if(curLevel1 < tmpNavArray.length -1){
                this.selectedNavItem = tmpNavArray[curLevel1];
            }
            else{
                this.selectedNavItem = tmpNavArray[0];
            }
        }

        if(!this.title && this.selectedNavItem){
            this.title = this.selectedNavItem.name;
        }

        this.navItems$.next(tmpNavArray);
    }

    onSelectNavLevel(navItem) {
        this.lgvFormSvc.navigate(navItem.level, -1);
    }

}
